if (!customElements.get('orienx-mobile-search')) {
  customElements.define('orienx-mobile-search', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      this.panel = this.querySelector('[data-search-panel]');
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.results = this.querySelector('[data-search-results]');
      this.browse = this.querySelector('[data-search-browse]');
      this.status = this.querySelector('[data-search-status]');
      this.all = this.querySelector('[data-search-all]');
      this.clear = this.querySelector('[data-search-clear]');
      this.sequence = 0;
      this.composing = false;
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-ox-mobile-search-open]');
        if (trigger) {
          event.preventDefault();
          this.open(trigger);
        } else if (event.target.closest('[data-ox-mobile-toggle],[data-ox-cart-open]')) {
          this.close(false, true);
        }
      }, { signal });
      this.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
      this.clear.addEventListener('click', () => { this.input.value = ''; this.update(); this.input.focus(); }, { signal });
      this.input.addEventListener('compositionstart', () => { this.composing = true; this.cancelRequest(); }, { signal });
      this.input.addEventListener('compositionend', () => { this.composing = false; this.update(); }, { signal });
      this.input.addEventListener('input', () => { if (!this.composing) this.update(); }, { signal });
      this.form.addEventListener('submit', (event) => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (!this.classList.contains('is-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key !== 'Tab') return;
        const items = [...this.panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !this.panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
      }, { signal });
      window.addEventListener('resize', () => { if (window.innerWidth > 1180) this.close(false, true); }, { signal });
      window.addEventListener('pagehide', () => this.close(false, true), { signal });
    }
    open(trigger) {
      clearTimeout(this.closeTimer);
      this.returnFocus = trigger;
      document.dispatchEvent(new CustomEvent('ox:mobile-search-open'));
      this.background = [...document.querySelectorAll('#MainContent, body > footer, .ox-header__bar')].map(el => ({ el, inert: el.inert }));
      this.background.forEach(({ el }) => { el.inert = true; });
      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');
      this.panel.inert = false;
      void this.panel.offsetWidth;
      this.classList.add('is-open');
      document.documentElement.classList.add('ox-search-open');
      document.querySelectorAll('[data-ox-mobile-search-open]').forEach(el => el.setAttribute('aria-expanded', 'true'));
      this.input.focus({ preventScroll: true });
      this.update();
    }
    close(restore = true, immediate = false) {
      if (this.hidden) return;
      clearTimeout(this.closeTimer);
      this.cancelRequest();
      this.input.blur();
      this.background?.forEach(({ el, inert }) => { el.inert = inert; });
      this.background = null;
      this.panel.inert = true;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ox-search-open');
      document.querySelectorAll('[data-ox-mobile-search-open]').forEach(el => el.setAttribute('aria-expanded', 'false'));
      const done = () => {
        this.hidden = true;
        if (restore) {
          const fallback = document.querySelector('.ox-header__mobile-actions [data-ox-mobile-search-open]');
          const target = this.returnFocus?.getClientRects().length ? this.returnFocus : fallback;
          target?.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('ox:mobile-search-close'));
      };
      if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else this.closeTimer = setTimeout(done, 480);
    }
    cancelRequest() {
      clearTimeout(this.debounce);
      clearTimeout(this.requestTimeout);
      this.request?.abort();
      this.sequence++;
      this.results?.removeAttribute('aria-busy');
    }
    update() {
      this.cancelRequest();
      const term = this.input.value.trim();
      this.clear.hidden = !term;
      this.browse.hidden = !!term;
      this.results.hidden = !term;
      this.all.hidden = !term;
      this.results.replaceChildren();
      this.status.classList.remove('ox-header__sr-only');
      this.status.textContent = '';
      if (!term) return;
      const allUrl = new URL(this.form.action);
      allUrl.searchParams.set('q', term);
      allUrl.searchParams.set('type', 'product,page,article');
      allUrl.searchParams.set('options[prefix]', 'last');
      this.all.href = allUrl.href;
      this.status.textContent = this.dataset.loading;
      this.results.setAttribute('aria-busy', 'true');
      const sequence = this.sequence;
      this.debounce = setTimeout(() => this.load(term, sequence), 220);
    }
    async load(term, sequence) {
      const request = new AbortController();
      this.request = request;
      this.requestTimeout = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL(this.dataset.suggestUrl, location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('section_id', 'orienx-mobile-predictive');
        url.searchParams.set('resources[type]', 'product,article,page');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[limit_scope]', 'each');
        let response = await fetch(url.href, { signal: request.signal, headers: { Accept: 'text/html' } });
        if (response.status === 417) {
          const fallback = new URL(this.form.action);
          fallback.searchParams.set('q', term);
          fallback.searchParams.set('type', 'product,page,article');
          fallback.searchParams.set('section_id', 'orienx-mobile-predictive');
          response = await fetch(fallback.href, { signal: request.signal, headers: { Accept: 'text/html' } });
        }
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-ox-predictive-content]');
        if (!content) throw new Error('Search unavailable');
        if (sequence !== this.sequence || !this.classList.contains('is-open')) return;
        this.results.replaceChildren(...content.childNodes);
        this.status.textContent = this.dataset.updated;
        this.status.classList.add('ox-header__sr-only');
      } catch (error) {
        if (sequence !== this.sequence || !this.classList.contains('is-open')) return;
        this.status.classList.remove('ox-header__sr-only');
        this.status.textContent = this.dataset.error;
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.requestTimeout);
          this.results.removeAttribute('aria-busy');
        }
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.background?.forEach(({ el, inert }) => { el.inert = inert; });
      this.cancelRequest();
      clearTimeout(this.closeTimer);
      document.documentElement.classList.remove('ox-search-open');
      this.events = null;
    }
  });
}

